export const locale = {
  lang: 'zh1',
  data: {
    'CONTRO_ENCU': {
      'TIT_ENCABE':'測繪控制',
       'CHAN_INFO':'加載信息',
       'TEX_INTRUCC':'* 通過選擇過濾器執行搜索',
       'SELEC_INSTI':'研究所',
       'SELEC_YEA':'年份',
       'SELEC_TI_ENC':'產品',
       'SELEC_ESTA':'狀態',
       'BTN_FIL_INFO':'過濾調查',
       'COMFI_UPDA_TEX':'確定要更新嗎？',
       'BTN_ACEP':'接受',
       'BTN_CANC':'取消',
       'TEX_MOD_UPTD':'更新中',
       'TEX_SUCC_MOD_UPTD':'升級成功',
       'USE':'用戶:',
       'DAT':'日期：',
       'ACC':'動作：',
       'ACC_EVENT':{
       '0':'停用',
       '1':'啟用',
     },
      'NAM_TH':{
         'TH_NAM':'公司',
          'TH_TI_ENCU':'調查類型',
          'TH_DAT_APLI':'申請日期',
          'TH_ESTA':'狀態',
          'TH_TOKE':'令牌',
          'TH_HC':'HC',
          'TH_RESPU':'響應',
          'TH_DAT_CLO':'截止日期',
          'TH_PRORR':'翻轉',
          'TH_REPO_EXC':'Excel 報告',
          'TH_ONLI':'在線',
          'TH_OFFLI':'離線',
          'TH_AUDIT':'審核',
          'TH_SECT':'扇區',
          'TH_SUBSECT':'子扇區',
          'TH_LIPROY':'項目負責人',
          'TH_JEFPROY':'項目負責人',
      }
    },

  }
};
